$ = require 'jquery'
CreateOrgView = require 'views/organization/create-org-view'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class BusinessClassSelectOrgView extends View
  events:
    'click .js-select-org': 'chooseOrg'
    'click .js-disabled': 'stop'
    'click .js-create-org': 'createOrg'

  render: ->
    data = {}

    if @model.organizationList.length > 0
      data.orgs = @model.organizationList.map (org) =>
        isAdmin = org.owned()
        isPremium = org.isPremium()
        needsBCUpgrade = org.needsBCUpgrade()
        isDisabled = !needsBCUpgrade || !isAdmin
        isBC2PO = org.isBC2PO()

        orgUrl = if isAdmin && (!isPremium || needsBCUpgrade)
          "/#{org.get('name')}/billing"
        else
          "#"

        memberCount = org.get('memberships').length

        _.extend(org.toJSON(), { memberCount, isAdmin, isPremium, needsBCUpgrade, orgUrl, isDisabled, isBC2PO })

    @$el.html(
      templates.fill(
        'select_org_to_upgrade',
        data
      )
    )

    @

  chooseOrg: (e) ->
    track("Select Team to Upgrade", "Choose Team")

  stop: (e) ->
    Util.stop(e)

  createOrg: (e) ->
    Util.stop(e)

    PopOver.toggle
      elem: $(e.target)
      top: 20
      view: CreateOrgView
      options: { @model, @modelCache, createOpts: { isBusinessClass: true } }

    track("Business Class Choose Org Page", "Create New Org")

    return



// WEBPACK FOOTER //
// ./app/scripts/views/organization/business-class-select-org-view.coffee